import React from 'react';
import './PolicyPurchaseToast.css';
import PlayerFactionIcon from '../PlayerFactionIcon/PlayerFactionIcon';
import {getPolicyImagePath} from '../../utils/policy/getPolicyImagePath';
import {getPlayerHexColor} from '../../utils/players/getPlayerHexColor';

/**
 * Плашка «игрок купил политику»: правая граница цветом игрока, справа во всю
 * высоту изображение политики, слева две строки — ник с иконкой фракции и
 * крупно название политики.
 *
 * Отвечает только за внешний вид. Где плашка висит и как появляется — дело
 * владельца: на витрине главного меню это MenuDemoPolicyToast (выезжает
 * из-за края поля), в матче — MatchPolicyToast (элемент общего стека тостов).
 * Размеры внутри заданы переменными --policy-toast-*, поэтому владельцу
 * достаточно переопределить их, а не дублировать правила.
 */
function PolicyPurchaseToast({player, policy, className, isCompact}) {
  if (!player || !policy) return null;

  // Ник — цветом игрока, как в тосте-реакции и на плашках состава: цвет тут
  // единственная привязка строки к конкретному участнику матча
  const playerColor = getPlayerHexColor(player.color);

  return (
    <div
      className={`policy-purchase-toast${isCompact ? ' policy-purchase-toast_compact' : ''}${className ? ` ${className}` : ''}`}
      style={{borderRightColor: playerColor, '--policy-toast-player-color': playerColor}}
    >
      <img
        className="policy-purchase-toast_image"
        src={getPolicyImagePath(policy.id)}
        alt={policy.name}
      />
      <div className="policy-purchase-toast_text">
        <div className="policy-purchase-toast_player">
          <PlayerFactionIcon
            player={player}
            skinId={player.selectedSkin}
            className="policy-purchase-toast_faction-icon"
            imgClassName="policy-purchase-toast_faction-icon-img"
          />
          <span className="policy-purchase-toast_player-name">{player.name}</span>
        </div>
        <div className="policy-purchase-toast_policy-name">{policy.name}</div>
      </div>
    </div>
  );
}

export default PolicyPurchaseToast;
